(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('CustomSegmentManageModalController', CustomSegmentManageModal);

    CustomSegmentManageModal.$inject = ['$scope', 'customSegment', 'close'];

    function CustomSegmentManageModal($scope, customSegment, close) {
        var vm = this;
        vm.INTEGER_REGEXP = /^\-?\d+$/;
        var emptyCustomSegment = {
            name: undefined,
            s3Key: undefined,
            description: undefined,
            public: false,
            valueLabels: {
                data: []
            }
        };

        if (angular.isUndefined(customSegment)) {
            vm.customSegment = angular.copy(emptyCustomSegment);
            vm.action = 'create';
        }
        else {
            vm.customSegment = angular.copy(customSegment);
            vm.action = 'update';
        }


        vm.clear = function () {
            vm.customSegment = angular.copy(emptyCustomSegment);
        };

        vm.setPublic = function (isPublic) {
            vm.customSegment.public = isPublic;
            $scope.customSegmentForm.$pristine = false;
            return false;
        };

        vm.save = function () {
            close({
                action: vm.action,
                customSegment: vm.customSegment
            }, 500);
        };

        vm.allowSave = function () {
            return !angular.equals(vm.customSegment, emptyCustomSegment) && !angular.equals(vm.customSegment, customSegment);
        };

        vm.verifyCustomSegmentValue = function (input, index) {

            var currentValue = input.$modelValue;

            var isDuplicate = false;
            angular.forEach(vm.customSegment.valueLabels.data, function (valueLabel, idx) {
                if (currentValue == valueLabel.value && idx != index) {
                    isDuplicate = true;
                }
            });
            input.$setValidity('duplicate', !isDuplicate);

        }
    }
})();